module.exports = __webpack_public_path__ + "static/media/mapMarker.cd3dd724.svg";